import { Form, Input } from 'antd'
import dayjs from 'dayjs';
import React, { useEffect } from 'react'
import TableDocument from './TableDocument';

const COADetails = ({ dataSource }) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (form && dataSource) {
            const payload = {
                ...dataSource,
                PublishDate: dayjs(dataSource.PublishDate).format('YYYY-MM-DD')
            }
            form.setFieldsValue(payload);
        }
    }, [form, dataSource]);

    return (
        <div>

            <Form
                name="basic"
                layout="vertical"
                // onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                autoComplete="off"
                form={form}
            >
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-4 mb-0">

                    <Form.Item
                        label="COA Code"
                        name="COACode"
                    >
                        <Input placeholder="COA Code" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Order Quotation"
                        name="OrderQuotation"
                    >
                        <Input placeholder="OrderQuotation" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Order Date"
                        name="OrderDate"
                    >
                        <Input placeholder="OrderDate" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Customer Name"
                        name="CustomerName"
                    >
                        <Input placeholder="CustomerName" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Contact Person"
                        name="ContactPerson"
                    >
                        <Input placeholder="ContactPerson" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Email Contact"
                        name="EmailContact"
                    >
                        <Input placeholder="EmailContact" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Phone"
                        name="Phone"
                    >
                        <Input placeholder="Phone" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Mobile Phone"
                        name="MobilePhone"
                    >
                        <Input placeholder="MobilePhone" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Report Number"
                        name="ReportNumber"
                    >
                        <Input placeholder="Report Number" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Publish Date"
                        name="PublishDate"
                    >
                        <Input placeholder="Publish Date" disabled />
                    </Form.Item>

                    <Form.Item
                        label="Status"
                        name="Status"
                    >
                        <Input placeholder="Status" disabled />
                    </Form.Item>
                </div>

            </Form>

            <TableDocument dataSouce={dataSource} />

        </div>
    )
}

export default COADetails;